import { render, staticRenderFns } from "./tab_user_gua.vue?vue&type=template&id=5f03522f&scoped=true"
import script from "./tab_user_gua.vue?vue&type=script&lang=js"
export * from "./tab_user_gua.vue?vue&type=script&lang=js"
import style0 from "./tab_user_gua.vue?vue&type=style&index=0&id=5f03522f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f03522f",
  null
  
)

export default component.exports